// General icons
import { FaWindowClose } from "react-icons/fa";
import { FaExternalLinkAlt } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";

// social icons
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { SiFrontendmentor } from "react-icons/si";

// skills icons
import { FaReact } from "react-icons/fa";
import { RiTailwindCssFill } from "react-icons/ri";
import { BiLogoMongodb } from "react-icons/bi";
import { FaBootstrap } from "react-icons/fa";
import { BiLogoTypescript } from "react-icons/bi";
import { FaNodeJs } from "react-icons/fa";
import { FaPhp } from "react-icons/fa";
import { SiMysql } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { SiRedux } from "react-icons/si";
import { SiMui } from "react-icons/si";

export const close_menu_icon = <FaWindowClose />;
export const LinkIcon = <FaExternalLinkAlt />;
export const Github = <FaGithub />;
export const DownloadIcon = MdOutlineFileDownload;

// images
export const logo = `/assets/logo.png`;
export const menu = `/assets/menu.svg`;
export const person = `/assets/person.png`;
export const arrows = `/assets/arrows.png`;
export const PorjectBgInfo = `/assets/background_project_info.jpg`;

export const socialMedia = [
  {
    icon: <FaGithub />,
    url: "https://github.com/Safi100",
  },
  {
    icon: <FaLinkedin />,
    url: "https://www.linkedin.com/in/safi-nafi-97434a35a/",
  },
  {
    icon: <SiFrontendmentor />,
    url: "https://www.frontendmentor.io/profile/Safi100",
  },
];

export const skills = [
  {
    icon: <FaGithub />,
    alt: "github",
  },
  {
    icon: <FaReact />,
    alt: "react",
  },
  {
    icon: <FaNodeJs />,
    alt: "nodejs",
  },
  {
    icon: <FaPhp />,
    alt: "php",
  },
  {
    icon: <RiTailwindCssFill />,
    alt: "tailwindcss",
  },
  {
    icon: <BiLogoMongodb />,
    alt: "mongodb",
  },
  {
    icon: <SiMysql />,
    alt: "mysql",
  },
  {
    icon: <FaBootstrap />,
    alt: "bootstrap",
  },
  {
    icon: <BiLogoTypescript />,
    alt: "typescript",
  },
  {
    icon: <SiExpress />,
    alt: "expressJs",
  },
  {
    icon: <SiMui />,
    alt: "MUI",
  },
  {
    icon: <SiRedux />,
    alt: "Redux",
  },
];

export const WhatIcanDo = [
  "Landing pages.",
  "Email templates.",
  "Responsive web design.",
  "Full-stack development.",
  "Develop and integrate RESTful APIs.",
  "DATABASE design.",
];

export const topProjects = [
  {
    title: "Water distribution dashboard",
    images: [
      "https://res.cloudinary.com/dfscdodag/image/upload/v1751128470/portfolio/water_mangaement_1_nbwr20.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1751128470/portfolio/water_mangaement_2_exsv2m.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1751128470/portfolio/water_mangaement_3_ua7jok.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1751128964/portfolio/water_mangaement_4_skzjqj.png",
    ],
    project_link:
      "https://github.com/Safi100/smart-water-distribution-management-dashboard",
    project_full_images:
      "https://github.com/Safi100/smart-water-distribution-management-dashboard/blob/main/Water%20distribution%20and%20management%20dashboard%20images.pdf",
    tools: ["React", "Context API", "Chart.js", "MAPBOX"],
  },
  {
    title: "Gaming platform",
    images: [
      "https://res.cloudinary.com/dfscdodag/image/upload/v1736180191/portfolio/keeplay_1_uf86p8.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1736180192/portfolio/keeplay_2_ybyzyu.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1736180191/portfolio/keeplay_3_j3rcqs.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1736180192/portfolio/keeplay_4_wbbuya.png",
    ],
    project_link: "https://github.com/Safi100/Gaming-hub-app",
    project_full_images:
      "https://github.com/Safi100/Gaming-hub-app/blob/main/Gaming%20hub%20app%20project%20images.pdf",
    tools: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Context API",
      "Socket.io",
    ],
  },
  {
    title: "Yelp Camp",
    images: [
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823545/portfolio/yelp_4_ohbaco.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823552/portfolio/yelp_1_qq7yxf.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823553/portfolio/yelp_2_xhizij.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823554/portfolio/yelp_3_zq4rcy.png",
    ],
    project_link: "https://github.com/Safi100/YelpCamp",
    project_full_images:
      "https://github.com/Safi100/YelpCamp/blob/master/YelpCamp%20project_images.pdf",
    tools: ["Node.js", "Express.js", "MongoDB", "Bootstrap", "Passport.js"],
  },
  {
    title: "E-Commerce App",
    images: [
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823548/portfolio/ecom_1_krnken.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823549/portfolio/ecom_2_t8ecmp.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823550/portfolio/ecom_3_snff5q.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823551/portfolio/ecom_4_tcbzwd.png",
    ],
    project_link: "https://github.com/Safi100/e_commerce-app",
    project_full_images:
      "https://github.com/Safi100/e_commerce-app/blob/main/e-commerce%20app%20pages.pdf",
    tools: ["React", "Node.js", "Express.js", "MongoDB", "Context API", "MUI"],
  },
  {
    title: "E-commerce dashboard",
    images: [
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823545/portfolio/dashboard_1_v0zhzc.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823545/portfolio/dashboard_2_kqonwf.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823546/portfolio/dashboard_3_rqn1qf.png",
      "https://res.cloudinary.com/dfscdodag/image/upload/v1737823547/portfolio/dashboard_4_nx20bl.png",
    ],
    project_link: "https://github.com/Safi100/e-commerce_admin_dashboard",
    project_full_images:
      "https://github.com/Safi100/e-commerce_admin_dashboard/blob/main/e-commerce_admin_dashboard%20pages.pdf",
    tools: ["React", "Node.js", "Express.js", "MongoDB", "Context API", "MUI"],
  },
];

export const projects = [
  {
    title: "SAAS Landing Page",
    description: "Landing page design using REACT and CSS",
    github_link: "https://github.com/Safi100/Saas-landing-page",
    live_page: "https://safi100.github.io/Saas-landing-page/",
    technologies: ["REACT", "CSS"],
  },
  {
    title: "Apple iphone 15 clone",
    description:
      "iphone 15 page clone using GSAP and Three.js with tailwind CSS.",
    github_link: "https://github.com/Safi100/gsap-3d-apple-clone",
    live_page: "https://safi100.github.io/gsap-3d-apple-clone/",
    technologies: ["GSAP", "Three.js", "React", "Tailwind CSS"],
  },
  {
    title: "Rock paper scissors game",
    description:
      "A simple rock paper scissors game using React and css with local storage.",
    github_link: "https://github.com/Safi100/rock-paper-scissors-game",
    live_page: "https://safi100.github.io/rock-paper-scissors-game/",
    technologies: ["React", "CSS", "Local Storage"],
  },
  {
    title: "Github profile search",
    description: "A simple github profile search API using javascript.",
    github_link: "https://github.com/Safi100/Github_search_API",
    live_page: "https://safi100.github.io/Github_search_API/",
    technologies: ["HTML", "CSS", "JS", "API"],
  },
  {
    title: "REST Countries API with color theme switcher",
    description:
      "REST Countries API that have filter and search, with color theme switcher.",
    github_link:
      "https://github.com/Safi100/rest-countries-api-with-color-theme-switcher/",
    live_page:
      "https://safi100.github.io/rest-countries-api-with-color-theme-switcher/",
    technologies: ["HTML", "CSS", "JS", "API"],
  },
  {
    title: "CMT Group Landing Page",
    description:
      "a simple landing page design using HTML, CSS and JS with multiple languages.",
    github_link: "https://github.com/Safi100/cmt-group",
    live_page: "https://safi100.github.io/cmt-group/",
    technologies: ["HTML", "CSS", "JS"],
  },
  {
    title: "Modern TODO App",
    description:
      "Todo app using React with local storage with nice features like dark mode and font theme.",
    github_link: "https://github.com/Safi100/modern-todo-app",
    live_page: "https://modern-todo-app-three.vercel.app/",
    technologies: ["React", "Context API", "Local Storage"],
  },
];

export const contact = {
  email: { title: "safinafi12@gmail.com", link: "mailto:safinafi12@gmail.com" },
  linked_in: {
    title: "linkedin.com/in/safi-nafi-97434a35a",
    link: "https://www.linkedin.com/in/safi-nafi-97434a35a/",
  },
  github: { title: "github.com/Safi100", link: "https://github.com/Safi100" },
  twitter: { title: "@safinafi2", link: "https://x.com/safinafi2" },
};
